import { gql } from '@apollo/client';

export const listGroups = gql`
  query listGroups($pagination: PaginationInput, $filter: GroupFilter) {
    listGroups(pagination: $pagination, filter: $filter) {
      id
      name
      description
      members {
        id
        user {
          id
          name
          email
        }
      }
      pendingInvitations {
        id
        name
        email
      }
      membersCount
    }
  }
`;

export const listMembers = gql`
  query listMembers($pagination: PaginationInput, $filter: MemberFilter) {
    listMembers(pagination: $pagination, filter: $filter) {
      id
      user {
        id
        name
        email
      }
    }
  }
`;

export const listInvitations = gql`
  query listInvitations($pagination: PaginationInput, $organizationId: ID!) {
    listInvitations(pagination: $pagination, organizationId: $organizationId) {
      id
      name
      email
      status
    }
  }
`;

export const listShares = gql`
  query listShares($organizationId: ID!, $playlistId: ID!) {
    listShares(organizationId: $organizationId, playlistId: $playlistId) {
      id
      groupId
      organizationPlaylistId
      type
      userId
    }
  }
`;

export const listPendingPlaylistShares = gql`
  query listPendingPlaylistShares($organizationId: ID!, $playlistId: ID!) {
    listPendingPlaylistShares(
      organizationId: $organizationId
      playlistId: $playlistId
    ) {
      id
      name
      email
    }
  }
`;
